import React, { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import { getAPIBaseURL } from '../../services/helpers'
import { getData } from '../../services/request'

const InfoRow = ({ label, value }) => (
  <div className="grid grid-cols-3 gap-4 border-b border-gray-100 py-3 text-sm">
    <div className="col-span-1 font-medium text-gray-600">{label}</div>
    <div className="col-span-2 text-gray-900">{value || '—'}</div>
  </div>
)

const AdminEmploymePaymentDetails = () => {
  const { jobId } = useParams()
  const [job, setJob] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  const fetchJob = async () => {
    setLoading(true)
    setError('')
    const url = `${getAPIBaseURL()}/employme/admin/jobs/${jobId}`
    const res = await getData(url, {}, {})
    setLoading(false)
    if (res.error === '') {
      if (res.result?.status === 200) {
        const data = res.result.data?.data || res.result.data
        setJob(data)
      } else {
        setError(res.result?.data?.message || res.result?.data?.data || 'Payment not found')
      }
    } else {
      setError(res.result?.data?.message || res.result?.data?.data || 'Network error')
    }
  }

  useEffect(() => {
    fetchJob()
  }, [jobId])

  const formatDate = (iso) => {
    try {
      return new Date(iso).toLocaleString()
    } catch {
      return iso || '—'
    }
  }

  const formatCurrency = (amount) => {
    if (amount == null || amount === undefined) return '—'
    return new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(amount)
  }

  const employerName = () => {
    const u = job?.createdByUserId
    if (!u) return '—'
    return `${u.firstName || ''} ${u.lastName || ''}`.trim() || u.email || '—'
  }

  if (loading) {
    return (
      <section className="mx-auto max-w-4xl">
        <div className="p-8 text-center text-sm text-gray-500">Loading...</div>
      </section>
    )
  }

  if (error || !job) {
    return (
      <section className="mx-auto max-w-4xl">
        <div className="mb-4 rounded-lg border border-red-200 bg-red-50 p-4 text-sm text-red-700">
          {error || 'Payment not found'}
        </div>
        <Link
          to="/admin/app/employme/payments"
          className="inline-block rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
        >
          Back to Employ Me Payments
        </Link>
      </section>
    )
  }

  return (
    <section className="mx-auto max-w-4xl">
      <div className="mb-4">
        <Link
          to="/admin/app/employme/payments"
          className="inline-flex items-center text-sm font-medium text-gray-600 hover:text-gray-900"
        >
          ← Back to Employ Me Payments
        </Link>
      </div>

      {error && (
        <div className="mb-4 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">{error}</div>
      )}

      <div className="rounded-lg border border-gray-200 bg-white shadow-sm">
        <div className="border-b border-gray-200 px-6 py-4">
          <h1 className="text-xl font-bold text-gray-900">{job.title}</h1>
          <p className="mt-1 text-sm text-gray-500">
            Payment: {formatCurrency(job.paymentAmount)} • {job.paymentStatus || 'completed'}
          </p>
        </div>
        <div className="divide-y divide-gray-100 px-6">
          <InfoRow label="Job Status" value={job.status} />
          <InfoRow label="Payment Status" value={job.paymentStatus} />
          <InfoRow label="Amount" value={formatCurrency(job.paymentAmount)} />
          <InfoRow label="Payment Reference" value={job.paymentTxRef} />
          <InfoRow label="Company" value={job.companyId?.name} />
          <InfoRow label="Employer" value={employerName()} />
          <InfoRow label="Contact Email" value={job.companyId?.contactEmail || job.createdByUserId?.email} />
          <InfoRow label="Employment Type" value={job.employmentType} />
          <InfoRow label="Location Type" value={job.locationType} />
          <InfoRow label="Application Deadline" value={formatDate(job.applicationDeadline)} />
          <InfoRow label="Applicants" value={job.applicantCount ?? 0} />
          <InfoRow label="Paid At" value={formatDate(job.updatedAt)} />
          <InfoRow label="Job Created" value={formatDate(job.createdAt)} />
        </div>
        <div className="border-t border-gray-200 px-6 py-4">
          <h3 className="mb-2 text-sm font-semibold text-gray-900">Description</h3>
          <div className="whitespace-pre-wrap text-sm text-gray-700">{job.description}</div>
        </div>
      </div>
    </section>
  )
}

export default AdminEmploymePaymentDetails
